
import { supabase } from './supabaseClient';
import { DataCategory } from '../types';

export const fetchDataCategories = async () => {
  const { data, error } = await supabase
    .from('data_categories')
    .select('*')
    .order('name', { ascending: true });

  if (error) throw error;
  return data as DataCategory[];
};

export const createDataCategory = async (name: string, keywords: string[] = []) => {
  const { data, error } = await supabase
    .from('data_categories')
    .insert({ name, keywords })
    .select()
    .single();

  if (error) throw error;
  return data as DataCategory;
};

export const updateDataCategory = async (id: number, updates: Partial<DataCategory>) => {
  const { data, error } = await supabase
    .from('data_categories')
    .update(updates)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as DataCategory;
};

export const deleteDataCategory = async (id: number) => {
  // 1. Check for usage in public_data_points
  const { count, error: countError } = await supabase
    .from('public_data_points')
    .select('*', { count: 'exact', head: true })
    .eq('category_id', id);

  if (countError) throw countError;

  if (count && count > 0) {
    throw new Error(`Cannot delete: This category is used by ${count} data point(s).`);
  }

  // 2. Delete if safe
  const { error } = await supabase
    .from('data_categories')
    .delete()
    .eq('id', id);

  if (error) throw error;
};
